export enum EAdvancePaymentCalculatorAnimationDelay {
  TITLE = 0,
  FORM = 500,
}
